import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames/bind';
import shapes from '@client/shared/js/shapes';
import themeStyles from '@client/shared/styles/theme/theme-styles.scss';
import styles from './phoneticsSection.scss';

class PhoneticsSection extends PureComponent {
  getPhoneticsClassname() {
    return classNames({
      [styles.phoneticsSection]: true,
      [this.props.className]: this.props.className,
    });
  }

  backgroundLineEffect = () => {
    if (this.props.backgroundLines) {
      return (
        <div
          className={`${themeStyles.hideOnMobile} ${styles.extraBackground}`}
        />
      );
    }
  };

  render() {
    const { title, phonetics, description } = this.props;
    return (
      <>
        <div className={this.getPhoneticsClassname()}>
          <div className={styles.titleAndPhoneticsContainer}>
            <div className={`${themeStyles.phoneticsTitle} ${styles.title}`}>
              {title}
            </div>
            <div className={`${themeStyles.phonetics} ${styles.phonetics}`}>
              {phonetics}
            </div>
          </div>
          <div className={themeStyles.phoneticsDescription}>{description}</div>
          <img
            className={`${themeStyles.hideOnDesktop} ${styles.shapeBottomLeft}`}
            src={shapes.graphic_panel}
            alt="Factuals graphic panel"
          />
        </div>
        {this.backgroundLineEffect()}
      </>
    );
  }
}

PhoneticsSection.propTypes = {
  className: PropTypes.string,
  title: PropTypes.string,
  phonetics: PropTypes.string,
  description: PropTypes.string,
  backgroundLines: PropTypes.bool,
};

export default PhoneticsSection;
